import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Sidebar       from '../../component/DashboardUI/Sidebar';
import Topbar        from '../../component/DashboardUI/Topbar';
import { Badge, StatCard, Panel, ActivityList, ProgressBar, TrackCell, statusBadge } from '../../component/DashboardUI/UI';
import { ThemeProvider } from '../../hooks/useTheme';
import { JUDGE, JUDGE_NAV, QUEUE, ACTIVITY_JUDGE, SCORE_DIST } from '../../data/mockData';
import '../../asset/css/main.css';

export default function JudgeDashboard() {
  return (
    <ThemeProvider>
      <PageContent />
    </ThemeProvider>
  );
}

function PageContent() {
  const [sideOpen, setSideOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="page-shell">
      <Sidebar
        navLinks={JUDGE_NAV}
        user={JUDGE}
        isJudge={true}
        isOpen={sideOpen}
        onClose={() => setSideOpen(false)}
      />

      <div className="page-body">
        <Topbar title="Judge Dashboard" onMenuClick={() => setSideOpen(o => !o)} />

        <main className="page-content anim-up">

          {/* Stat row */}
          <div className="stat-row">
            <StatCard icon="📋" cls="gold"   val="24"   label="Pending Reviews"  delta="↑ 6 new today"    up   accent />
            <StatCard icon="✅" cls="green"  val="138"  label="Tracks Scored"    delta="This season"       up   accent />
            <StatCard icon="⭐" cls="red"    val="82.4" label="Avg Score Given"  delta="↓ 1.2 this week"  down accent />
            <StatCard icon="⏱" cls="purple" val="4.2d" label="Avg Review Time"  delta="↑ Faster than avg" up  accent />
          </div>

          {/* Alert banner */}
          <div style={{
            background: 'var(--gold-dim)', border: '1px solid rgba(255,183,3,0.25)',
            borderRadius: 12, padding: '1.1rem 1.5rem', marginBottom: '1.7rem',
            display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: '1.2rem' }}>⚠️</span>
            <div style={{ flex: 1, minWidth: 180 }}>
              <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--text)', textAlign: 'start' }}>24 tracks awaiting your review</div>
              <div style={{ fontSize: '0.77rem', color: 'var(--muted2)', marginTop: 2, textAlign: 'start' }}>Deadline: May 1, 2025 · 14 days remaining</div>
            </div>
            <button className="btn btn-gold btn-sm" onClick={() => navigate('/judge/examine')}>
              Start Reviewing →
            </button>
          </div>

          {/* Two-col layout */}
          <div className="row">
            {/* Left: queue table */}
            <div className="col-grow">
              <div>
                <div className="sec-head">
                  <h3>Review Queue</h3>
                  <button className="btn btn-ghost btn-sm" onClick={() => navigate('/judge/examine')}>View All</button>
                </div>
                <div className="tbl-wrap">
                  <table>
                    <thead><tr><th>Track</th><th>Artist</th><th>Genre</th><th>Status</th></tr></thead>
                    <tbody>
                      {QUEUE.map(q => (
                        <tr key={q.id} style={{ cursor:'pointer' }} onClick={() => navigate('/judge/examine')}>
                          <td><TrackCell img={q.art} title={q.title} sub="" /></td>
                          <td style={{ color:'var(--muted2)', fontSize:'0.82rem' }}>{q.artist}</td>
                          <td><Badge type="blue">{q.genre}</Badge></td>
                          <td>{statusBadge(q.status)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Right */}
            <div className="col-side">
              {/* Score dist */}
              <Panel title="Score Distribution">
                <div style={{ display:'flex', flexDirection:'column', gap:'0.55rem' }}>
                  {SCORE_DIST.map(d => (
                    <div key={d.label} style={{ display:'flex', alignItems:'center', gap:'0.7rem', fontSize:'0.8rem' }}>
                      <span style={{ width:70, color:'var(--muted2)', fontWeight:600, flexShrink:0 }}>{d.label}</span>
                      <div style={{ flex:1 }}><ProgressBar pct={d.pct} color="var(--gold)" /></div>
                      <span style={{ width:30, textAlign:'right', fontFamily:'Space Mono,monospace', fontSize:'0.68rem', color:'var(--muted2)' }}>{d.pct}%</span>
                    </div>
                  ))}
                </div>
              </Panel>

              <Panel title="Recent Activity">
                <ActivityList items={ACTIVITY_JUDGE} />
              </Panel>

              {/* Season progress */}
              <Panel style={{ background:'var(--green-dim)', border:'1px solid rgba(6,214,160,0.2)' }}>
                <div style={{ fontFamily:"'Bebas Neue',cursive", fontSize:'1rem', color:'var(--green)', marginBottom:'0.85rem' }}>Season Progress</div>
                {[{ label:'Tracks scored', val:138, max:162, pct:85 },{ label:'Feedback written', val:121, max:162, pct:75 }].map(p => (
                  <div key={p.label} style={{ marginBottom:'0.85rem' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', fontSize:'0.76rem', marginBottom:4 }}>
                      <span style={{ color:'var(--muted2)', fontWeight:600 }}>{p.label}</span>
                      <span style={{ fontFamily:'Space Mono,monospace', fontSize:'0.68rem', color:'var(--green)' }}>{p.val}/{p.max}</span>
                    </div>
                    <ProgressBar pct={p.pct} color="var(--green)" />
                  </div>
                ))}
              </Panel>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}